<div class="counts-card">
  <header class="counts-head">
    <span class="counts-eyebrow">{{ title }}</span>
  </header>

  <div class="counts-grid">
    @for (
      item of widgetPanelCounts.data | keyvalue: keyValuePairDefaultOrder;
      track item
    ) {
      @if (isObjectWithCount(item.value)) {
        <button
          type="button"
          class="stat-cell is-clickable"
          (click)="navigateToCountGrid(item)"
        >
          <div class="stat-label">{{ item.key }}</div>
          <div class="stat-value">{{ item.value.count }}</div>
        </button>
      } @else {
        <div class="stat-cell">
          <div class="stat-label">{{ item.key }}</div>
          <div class="stat-value">{{ item.value }}</div>
        </div>
      }
    }
  </div>
</div>
